module.exports = __webpack_public_path__ + "static/media/nonord-c-2.cda666c8.mp3";